//
// ReportPrivacyController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";

var ReportPrivacyController = createModule("BIRD::ReportPrivacyController", [], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        _canPrintVisual_o: [2,1],
        canPrintReport: [2],
        canPrintVisuals: [2,[7]],
        _canPrintVisual_s: [2,7],
    },
    ,
    ["canPrintVisual"],
]);
export default ReportPrivacyController;
